import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useTranslation } from '../../hooks/useTranslation';

const LOGO_URL = '/assets/images/ChatGPT_Image_Dec_1_2025_08_15_51_PM-1764613791088.png';

const VisitorCounter = () => {
  const { t } = useTranslation();
  const [count, setCount] = useState(null);
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    let isMounted = true;
    const run = async () => {
      const visitorKey = 'sh_mi_visitor_id';
      let visitorId = localStorage.getItem(visitorKey);

      try {
        if (!visitorId) {
          visitorId = crypto.randomUUID();
          localStorage.setItem(visitorKey, visitorId);
          const { data, error } = await supabase.functions.invoke('mi-register-visitor', {
            body: { visitor_id: visitorId },
          });
          if (!error && isMounted && data?.count != null) {
            setCount(data.count);
          }
        } else {
          const { data, error } = await supabase.rpc('get_mi_unique_visitor_count');
          if (!error && isMounted && data != null) {
            setCount(data);
          }
        }
      } catch (e) {
        // counter is non-critical, fail silently
      }
    };
    run();
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    if (count === null) return;
    const duration = 1100;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayCount(Math.floor(eased * count));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [count]);

  if (count === null) return null;

  return (
    <div className="flex justify-center py-6">
      <div className="flex items-center gap-3 rounded-full pl-2.5 pr-5 py-2" style={{ background: 'var(--bg-primary)', boxShadow: '0 4px 14px rgba(15,34,56,0.18)' }}>
        <div className="relative w-10 h-10 flex-shrink-0">
          <span className="absolute inset-[-6px] rounded-full" style={{ background: 'var(--primary)', opacity: 0.35, animation: 'mi-visitor-pulse 2s ease-out infinite' }} />
          <div className="relative w-10 h-10 rounded-full bg-white overflow-hidden flex items-center justify-center border-2" style={{ borderColor: 'var(--primary)' }}>
            <img src={LOGO_URL} alt="SugarHathi" className="w-[130%] h-[130%] object-cover" style={{ objectPosition: 'center 38%' }} />
          </div>
        </div>
        <div className="flex flex-col leading-tight">
          <span className="text-xl font-extrabold text-white tabular-nums">{displayCount.toLocaleString()}</span>
          <span className="text-[10px] uppercase tracking-wide" style={{ color: '#b9c4d0' }}>{t('marketIntelligence.totalVisitors')}</span>
        </div>
      </div>
      <style>{`
        @keyframes mi-visitor-pulse {
          0% { transform: scale(0.85); opacity: 0.45; }
          70% { transform: scale(1.6); opacity: 0; }
          100% { transform: scale(1.6); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default VisitorCounter;
